import styled from 'styled-components'

const ListContainer = styled.ul`
  height: 62vh;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  margin: -${(props) => props.spacing / 2}px;
  padding: 15px 0;
  display: flex;
  flex-wrap: wrap;
  display: ${(props) => !props.show && 'none'};
  position: relative;
  scrollbar-width: none;
`

export { ListContainer }
